import React, { ReactNode } from 'react';

import { OnboardingUpdates } from 'registration/types';

export type OnboardingVariantContextType = {
  currentStep: number;
  goToPreviousPage: () => void;
  intent: string;
  onboardVariant: string;
  setMostRecentCompletedStep: React.Dispatch<React.SetStateAction<number>>;
  setTalentProfileUpdates: React.Dispatch<
    React.SetStateAction<OnboardingUpdates>
  >;
  talentProfileUpdates: OnboardingUpdates;
  totalSteps: number;
};

const OnboardingVariantContext =
  React.createContext<OnboardingVariantContextType>(null);

type OnboardingVariantProviderProps = {
  children: ReactNode;
  config: OnboardingVariantContextType;
};

export const OnboardingVariantProvider = ({
  config,
  children,
}: OnboardingVariantProviderProps) => (
  <OnboardingVariantContext.Provider value={config}>
    {children}
  </OnboardingVariantContext.Provider>
);

export const useOnboardingVariantContext = () =>
  React.useContext(OnboardingVariantContext);
